// extracted by css-extract-rspack-plugin
export default {"divider":"qiQSJOwu8ddUeAma","methods":"FXcJql6FroalQQLZ","method":"f85Qp3rYiQ7hvE61"};